export const injectedEnvironment: Record<string, string> = {
  REACT_APP_BACKEND_BASE_URL: "https://sztnst0tdk.execute-api.eu-central-1.amazonaws.com/dev",
};
